import styled from 'styled-components'

export const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const TooltipCountsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const LegendSquare = styled.div`
  width: ${props => props.theme.size['3XS']};
  height: ${props => props.theme.size['3XS']};
  background-color: ${props => props.color};
  border-radius: 2px;
`
